import { render, staticRenderFns } from "./ScanSign.vue?vue&type=template&id=0b70ceac&scoped=true"
import script from "./ScanSign.vue?vue&type=script&lang=js"
export * from "./ScanSign.vue?vue&type=script&lang=js"
import style0 from "./ScanSign.vue?vue&type=style&index=0&id=0b70ceac&prod&lang=scss&scoped=true"
import style1 from "./ScanSign.vue?vue&type=style&index=1&id=0b70ceac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70ceac",
  null
  
)

export default component.exports